export default function transformTagsToOptions(tags) {
  if (!tags) {
    return [];
  }
  return tags.map(tag => ({
    id: tag.id,
    label: tag.label,
  }));
}
